import {
  Box,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

import { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';

interface ViewStep1Props {
  formData: IComunidadesRuraisTradicionais;
}

export const ViewStep1: React.FC<ViewStep1Props> = ({
  formData,
}) => {
  console.log('formData', formData);

  const tiposAssentamento = [
    { value: 3, label: 'FEDERAIS – PA' },
    { value: 4, label: 'FEDERAIS CASULO/PCA (parceria entre INCRA e município)' },
    { value: 5, label: 'ESTADUAIS – PE' },
    { value: 6, label: 'PROJETOS DO TERRA BRASIL/ PROGRAMA NACIONAL DE CRÉDITO FUNDIÁRIO (PNCF)/ BANCO DA TERRA' },
  ];

  const tiposCadastro = [
    { value: 1, label: 'Assentamento' },
    { value: 2, label: 'Comunidade Quilombola' },
  ];

  const getTipoAssentamentoLabel = (value: number | null) => {
    if (!value) return '';
    return tiposAssentamento.find(tipo => tipo.value === value)?.label ?? '';
  };

  const getTipoCadastroLabel = (value: number | null) => {
    if (!value) return '';
    return tiposCadastro.find(tipo => tipo.value === value)?.label ?? '';
  };

  const isAssentamento = formData.tipo_cadastro === 1;
  const isCodigoPAVisivel = isAssentamento &&
    formData.tipo_de_assentamento &&
    [3, 4, 5].includes(formData.tipo_de_assentamento);

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant='h5'
        gutterBottom
        sx={{ fontWeight: 'bold', mb: 4, mt: 2 }}
      >
        Informações Básicas: {formData.nome_do_assentamento}
      </Typography>

      {/* Primeira linha: Ano de Referência e Tipo do Cadastro */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Ano de Referência do Questionário
          </Typography>
          <TextField
            fullWidth
            value={new Date().getFullYear() - 1}
            InputProps={{
              readOnly: true,
              sx: {
                backgroundColor: '#f5f5f5',
                '& input': {
                  textAlign: 'left',
                  fontWeight: 'normal',
                },
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Tipo do Cadastro
          </Typography>
          <TextField
            fullWidth
            value={getTipoCadastroLabel(formData.tipo_cadastro)}
            InputProps={{
              readOnly: true,
              sx: {
                backgroundColor: '#f5f5f5',
              },
            }}
          />
        </Grid>
      </Grid>

      {/* Segunda linha: Tipo de Assentamento e Código PA (condicionais) */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {isAssentamento && (
          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Tipo do Assentamento
            </Typography>
            <TextField
              fullWidth
              value={getTipoAssentamentoLabel(formData.tipo_de_assentamento)}
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: '#f5f5f5',
                },
              }}
            />
          </Grid>
        )}

        {isCodigoPAVisivel && (
          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Código
            </Typography>
            <TextField
              fullWidth
              value={formData.codigo_do_pa ? `${formData.codigo_do_pa}` : ''}
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: '#f5f5f5',
                },
              }}
            />
          </Grid>
        )}
      </Grid>

      {/* Terceira linha: Nome do Assentamento e Quantidade de Famílias */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Nome da Comunidade
          </Typography>
          <TextField
            fullWidth
            value={formData.nome_do_assentamento ?? ''}
            InputProps={{
              readOnly: true,
              sx: {
                backgroundColor: '#f5f5f5',
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Quantidade de Famílias
          </Typography>
          <TextField
            fullWidth
            value={formData.quantidade_de_familias ?? ''}
            InputProps={{
              readOnly: true,
              sx: {
                backgroundColor: '#f5f5f5',
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
